import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function Hero() {
  return <section className="w-full py-20 md:py-28 px-6 md:px-12 lg:px-24 bg-cream" data-id="element-108">
      <div className="max-w-4xl mx-auto text-center" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="space-y-10" data-id="element-110">
          {/* Line 1 — Brand */}
          <p className="text-base md:text-lg tracking-[0.3em] uppercase text-charcoal-light font-semibold" data-id="element-111">
            The Meltdown Vault
          </p>

          {/* Line 2 — Headline */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-charcoal leading-snug" data-id="element-112">
            Stop the Meltdown
            <br className="hidden sm:block" data-id="element-113" /> Before It Starts
          </h1>

          {/* Line 3 — Subheadline */}
          <p className="text-xl md:text-2xl text-charcoal-light" data-id="element-114">
            The 3-step protocol for parents of autistic children
          </p>

          {/* Line 4 — Product mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="py-6" data-id="element-115">
            <img src="https://cdn.magicpatterns.com/uploads/xaA16amrHUWJZ1gvG9Lou1/heylloyd-image-1777604473319.png" alt="The Crisis Calm Method — ebook, workbook, checklist and audio guide" className="w-full max-w-md mx-auto" data-id="element-116" />
          </motion.div>

          {/* Line 5 — Price */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="flex flex-wrap items-center justify-center gap-4" data-id="element-117">
            <span className="text-3xl md:text-4xl text-charcoal-light/40 line-through decoration-2" data-id="element-118">
              $47
            </span>
            <span className="text-5xl md:text-7xl font-serif text-charcoal font-bold" data-id="element-119">
              $17
            </span>
            <span className="bg-amber/15 text-amber font-bold text-base md:text-lg px-4 py-2 rounded-full uppercase tracking-wide" data-id="element-120">
              Today Only
            </span>
          </motion.div>

          {/* Line 6 — CTA Button */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.8
        }} data-id="element-121">
            <a href="#final-cta" className="inline-block w-full sm:w-auto bg-amber hover:bg-amber-hover text-white font-bold text-xl md:text-2xl px-14 py-5 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(217,138,44,0.3)] hover:shadow-[0_0_40px_rgba(217,138,44,0.5)] transform hover:-translate-y-0.5" data-id="element-122">
              GET INSTANT ACCESS
            </a>
          </motion.div>

          {/* Line 7 — Micro-guarantee */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 1
        }} className="flex items-center justify-center gap-2 text-charcoal-light text-base md:text-lg" data-id="element-123">
            <ShieldCheck className="w-5 h-5 text-sage shrink-0" data-id="element-124" />
            <span data-id="element-125">30-Day Money Back Guarantee — No Questions Asked</span>
          </motion.div>

          {/* Reviews */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 1.2
        }} className="pt-6" data-id="element-126">
            <h3 className="text-2xl md:text-3xl font-serif text-charcoal mb-8" data-id="element-127">
              Reviews
            </h3>
            <div className="grid sm:grid-cols-3 gap-5 text-left" data-id="element-128">
              <div className="bg-white border border-cream-dark rounded-2xl p-6 shadow-sm" data-id="element-129">
                <p className="text-charcoal text-base italic leading-relaxed mb-3" data-id="element-130">
                  "I used the protocol the night I downloaded this. He came down
                  in under 8 minutes."
                </p>
                <p className="text-sm font-semibold text-charcoal-light" data-id="element-131">
                  — Sarah M., Texas
                </p>
              </div>
              <div className="bg-white border border-cream-dark rounded-2xl p-6 shadow-sm" data-id="element-132">
                <p className="text-charcoal text-base italic leading-relaxed mb-3" data-id="element-133">
                  "This $17 guide explained my daughter's nervous system better
                  than 4 years of searching."
                </p>
                <p className="text-sm font-semibold text-charcoal-light" data-id="element-134">
                  — Jennifer K., California
                </p>
              </div>
              <div className="bg-white border border-cream-dark rounded-2xl p-6 shadow-sm" data-id="element-135">
                <p className="text-charcoal text-base italic leading-relaxed mb-3" data-id="element-136">
                  "The Yellow Zone Map alone was worth every penny."
                </p>
                <p className="text-sm font-semibold text-charcoal-light" data-id="element-137">
                  — David R., Ohio
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}